import { render, staticRenderFns } from "./notes_app.vue.js?vue&type=template&id=1c489624!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./notes_app.vue?vue&type=template&id=1c489624"
import script from "./notes_app.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./notes_app.vue?vue&type=script&lang=js"
export * from "./notes_app.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./notes_app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports